import type { ReactNode } from 'react'
import { GalleryPopup } from '#src/components/GalleryPopup.js'
import { getGalleryMeta, getGalleryPopupData } from '#src/data/data.js'
import { languageService } from '#src/languageService.js'
import { mergeMeta, noindexMeta } from '#src/seo.js'
import type { Route } from './+types/home-gallery.route.js'

export async function loader({ request, params }: Route.LoaderArgs) {
  const lang = languageService.langFromRequest(request)
  const [data, meta] = await Promise.all([
    getGalleryPopupData(params.gallerySlug, lang),
    getGalleryMeta(params.gallerySlug, lang),
  ])
  return { data, meta }
}

export function meta({ loaderData, matches }: Route.MetaArgs): Route.MetaDescriptors {
  return mergeMeta(matches[0].meta, [...(loaderData?.meta || []), noindexMeta])
}

export default function GalleryPopupPage({ loaderData }: Route.ComponentProps): ReactNode {
  return <GalleryPopup data={loaderData.data} backHref="/" />
}
